import client from '@/api/client';

const GET_FINANCIAL_INFORMATION = `v1/finans/`;

export default {
  getFinancialInformation() {
    return client.get(GET_FINANCIAL_INFORMATION);
  }
}
